(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/freja/same-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/freja/same-device.js');

'use strict';

const {
  Events: AuthenticateEvents
} = svs.accountservices.authenticate.definitions;
svs.player_login.views.freja.SameDevice = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.freja_same_device(data);
  },
  behaviors: {
    About: {
      behaviorClass: svs.player_login.behaviors.About
    },
    Navigation: {
      behaviorClass: svs.player_login.behaviors.Navigation
    }
  },
  ui: {
    loginButton: '.js-login'
  },
  events: {
    'click @ui.loginButton': 'onLoginClick'
  },
  initialize() {
    svs.accountservices.authenticate.login.on(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll, this);
  },
  onLoginClick() {
    this.triggerMethod('block:navigation');
    svs.accountservices.authenticate.login.start({
      method: svs.accountservices.authenticate.definitions.LoginMethods.FREJA,
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onReadyToPoll() {
    svs.player_login.router.navigate("freja/poll?".concat(this.model.toQueryString()), true);
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll);
  }
});

 })(window);